<template lang='pug'>
    #erro
        .erro_mensagem
            h1.erro_titulo Ocorreu um erro.
            p Por favor, verifique sua URL e tente novamente.
            .erro_acoes
                BaseButton(size='large' type='primary' @click='logout') Sair da platafoma

        img.erro_imagem(src='@/assets/mascote-lyra.png')
</template>

<script>
import store from '@/store';
import keycloakUtil from '@/utils/keycloak';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'Erro',

    components: {
        BaseButton
    },

    data() {
        return {};
    },

    methods: {
        logout() {
            window.location.href = keycloakUtil.getLogoutUrl();
            store.dispatch('clearMarcarExportar_PDF', null);
            store.dispatch('setUsuarioLogado', null);
        }
    }
};

</script>

<style lang='scss'>
#erro {
    height: 100vh;
    width: 100vw;
    gap: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--white);

    .erro_imagem {
        height: 400px;
    }
}
</style>
